import styles from "./styles.module.scss";
import { CSSProperties, useState } from "react";

import StyledIcon from "@generic-components/StyledIcon";
import { read } from "fs";

interface InputFieldProps {
  id: string;
  type: string;
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: CSSProperties | string;
  errorMsg?: string;
  isPassword?: boolean;
  showButton?: boolean;
  disable?: boolean;
  autoComplete?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  ref?: any;
  readOnly?: boolean;
  maxLength?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = ({
  id,
  type,
  placeholder,
  name,
  value,
  onChange,
  style,
  errorMsg,
  disable = false,
  isPassword = false,
  showButton = false,
  onBlur,
  ref,
  readOnly = false,
  onKeyDown,
  ...rest
}) => {
  const [inputType, setInputType] = useState(type);

  const handleIconClick = () => {
    setInputType(inputType === "text" ? "password" : "text");
  };

  return (
    <div className={styles.inputWrapper}>
      <input
        id={id}
        type={inputType}
        placeholder={placeholder}
        value={value}
        disabled={disable}
        onChange={onChange}
        className={`${styles.inputStyle} ${style}`}
        name={name}
        onBlur={onBlur}
        readOnly={readOnly}
        autoComplete="off"
        onKeyDown={onKeyDown}
        {...rest}
      />
      {isPassword && (
        <div
          onClick={handleIconClick}
          className={`${styles.iconCss} ${errorMsg && styles.iconBottomClass}`}
        >
          {inputType === "text" ? (
            <StyledIcon icon={"showPassword"} inline={true} />
          ) : (
            <StyledIcon icon={"hidePassword"} inline={true} />
          )}
        </div>
      )}
      {errorMsg && <div className={styles.errMsg}>{errorMsg}</div>}
    </div>
  );
};

export default InputField;
